var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.vis_data)?_c('div',[_c('highcharts',{staticClass:"pie-chart",attrs:{"options":_vm.heatmap_data()}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }